/** M-Pesa account reference max length (STK AccountReference field). */
export const PA_PAYMENT_REF_MAX_LEN = 12;

const PA_REF_PREFIX = 'PA-';

/**
 * Paybill / STK account number for Students PA — e.g. PA-37871676 (national ID).
 * GIS validatePayment matches EOP_ACCNUMBER on this value.
 */
export function buildPaPaymentReference(nationalId) {
  const digits = String(nationalId || '').replace(/\D/g, '');
  if (!digits) return '';
  const ref = `${PA_REF_PREFIX}${digits}`.toUpperCase();
  if (ref.length <= PA_PAYMENT_REF_MAX_LEN) return ref;
  const idMax = PA_PAYMENT_REF_MAX_LEN - PA_REF_PREFIX.length;
  return `${PA_REF_PREFIX}${digits.slice(-idMax)}`;
}

export function normalizePaPaymentReference(reference) {
  return String(reference || '').replace(/\s+/g, '').toUpperCase().slice(0, PA_PAYMENT_REF_MAX_LEN);
}
